import { type FC, useEffect, useRef } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconPlay } from '../../../icons'
import { NfcLandingPageTitle } from '../NfcLandingPageTitle/NfcLandingPageTitle'

import poster from './poster.jpg'

export const NfcLandingPageStepByStep: FC = () => {
  const videoRef = useRef<HTMLVideoElement>(null)
  const playButtonRef = useRef<HTMLButtonElement>(null)

  useEffect(() => {
    const videoEl = videoRef.current
    const playButtonEl = playButtonRef.current

    if (!videoEl || !playButtonEl) {
      return undefined
    }

    const onPlay = (): void => {
      playButtonEl.classList.add('hidden')
    }

    videoEl.addEventListener('play', onPlay, {
      once: true,
    })

    return (): void => {
      videoEl.removeEventListener('play', onPlay)
    }
  }, [])

  return (
    <div
      className="tablet:bg-gradient-to-b tablet:from-transparent tablet:from-25% tablet:to-light-brand-high tablet:to-25%"
      // id="sogehts" is used for external linking
      id="sogehts"
    >
      <div className="container tablet:pb-9 tablet:pt-3">
        <NfcLandingPageTitle className="mb-4 tablet:mb-6 tablet:text-center">
          <FormattedMessage id="nfc.stepByStep.title" />
        </NfcLandingPageTitle>
        <div className="relative">
          <video
            className="mx-auto rounded-2xl"
            controls
            height="360"
            poster={poster.src}
            ref={videoRef}
            src="https://static.shop-apotheke.com/media/nfc/nfc-step-by-step-explained.mp4"
            width="640"
          />
          <button
            className="pointer-events-none absolute left-1/2 top-1/2 flex size-20 -translate-x-1/2 -translate-y-1/2 flex-col items-center justify-center rounded-full bg-light-secondary-medium"
            ref={playButtonRef}
            type="button"
          >
            <IconPlay className="size-6 fill-dark-brand" />
            <span className="text-xs font-medium">
              <FormattedMessage id="product.details.gallery.videobubble.play" />
            </span>
          </button>
        </div>
      </div>
    </div>
  )
}
